import { View, StyleSheet, TouchableOpacity } from "react-native";
import { useState, useEffect } from "react";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { PlusCircle, Trash, EditIcon } from "../../svgIcons";
import CustomText from "../../common/general/CustomText/CustomText";
import { ScrollView } from "react-native-gesture-handler";
import { ListItem } from "@rneui/themed";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DeleteModuleModalContainer from "../../../containers/content/ContentModalContainers/DeleteModuleModalContainer";
import AddModuleModalContainer from "../../../containers/content/ContentModalContainers/AddModuleModalContainer";
import EditModuleNameModalContainer from "../../../containers/content/ContentModalContainers/EditModuleNameModalContainer";
import EditAssignmentModalContainer from "../../../containers/content/ContentModalContainers/EditAssignmentModalContainer";
import { useAppState, actions } from "../../../contexts/AppStateContext";

function ContentMenu({ data, topicName, onAssignmentPress }) {
  const courseId = data?.id;

  const { dispatch } = useAppState();

  const { isXLarge, isMedium, hp } = useResponsiveScreen();

  const [expandedModule, setExpandedModule] = useState(null);
  const [deleteModuleModalVisible, setDeleteModuleModalVisible] = useState(false);
  const [addModuleModalVisible, setAddModuleModalVisible] = useState(false);
  const [editModuleNameModalVisible, setEditModuleNameModalVisible] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState();
  const [selectedModule, setSelectedModule] = useState(null);

  const [EditAssignmentModalVisible, setEditAssignmentModalVisible] = useState(false);

  useEffect(() => {
    if (data?.modules?.length > 0 && data.modules[0].assignments?.length > 0) {
      const firstModule = data.modules[0];
      const firstAssignment = firstModule.assignments[0];
      setSelectedAssignment(firstAssignment.assignment_name);
      setSelectedModule(firstModule.module_name);
    }
  }, [data]);

  const handleAddModuleModalClose = () => {
    setAddModuleModalVisible(false);
  };
  const handleEditModuleNameModalClose = () => {
    setEditModuleNameModalVisible(false);
  };
  const handleAddModule = () => {
    dispatch({
      type: actions.SET_META,
      payload: { keypressIsListening: false },
    });
    setAddModuleModalVisible(true);
  };
  const handleEditModuleName = (moduleName) => {
    setSelectedModule(moduleName);
    dispatch({
      type: actions.SET_META,
      payload: { keypressIsListening: false },
    });
    setEditModuleNameModalVisible(true);
  };
  const handleDeleteModuleModalClose = () => {
    setDeleteModuleModalVisible(false);
  };

  const handleDeleteModule = (moduleName) => {
    setDeleteModuleModalVisible(true);
    console.log("moduleName: ", moduleName);
    dispatch({
      type: actions.SET_META,
      payload: { keypressIsListening: false },
    });
    setSelectedModule(moduleName);
  };

  const handleEditAssignment = (moduleName) => {
    setSelectedModule(moduleName);
    dispatch({
      type: actions.SET_META,
      payload: { keypressIsListening: false },
    });
    setEditAssignmentModalVisible(true);
  };
  const handleEditAssignmentModalClose = () => {
    setEditAssignmentModalVisible(false);
  };

  const handleAssignmentPress = (assignmentName, moduleName) => {
    setSelectedAssignment(assignmentName);
    onAssignmentPress(assignmentName, moduleName, data.name);
  };

  return (
    <View
      style={[styles.container, { maxWidth: isXLarge ? 400 : isMedium ? 240 : hp(100) }]}
      aria-live="polite"
      aria-label="Learn Menu"
      role="menu">
      <View style={styles.menuContainer}>
        <CustomText useTranslationText={false} text={topicName} size="xs" weight="bold" textType="display" />
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <CustomText
            role="header"
            aria-level="3"
            text="Modules"
            size="m"
            weight="ultraBold"
            textType="text"
            style={{ marginLeft: 20 }}
          />
          <CustomButton
            text="Add"
            leftIcon={<PlusCircle />}
            styleType="primaryLight"
            size="s"
            style={[styles.addButton, { marginLeft: isMedium ? "0" : "auto" }]}
            textStyle={styles.addText}
            bold={true}
            onPress={handleAddModule}
            aria-label="Add Module"
            accessibilityHint="Press to add Module"
          />
        </View>
      </View>
      <DeleteModuleModalContainer
        visible={deleteModuleModalVisible}
        onClose={handleDeleteModuleModalClose}
        courseId={courseId}
        moduleName={selectedModule}
      />

      <EditModuleNameModalContainer
        visible={editModuleNameModalVisible}
        onClose={handleEditModuleNameModalClose}
        moduleName={selectedModule}
        courseId={courseId}
      />
      <EditAssignmentModalContainer
        visible={EditAssignmentModalVisible}
        onClose={handleEditAssignmentModalClose}
        courseId={courseId}
        initialContent={""}
        currentAssignmentName={""}
        moduleName={selectedModule}
      />

      <AddModuleModalContainer
        visible={addModuleModalVisible}
        onClose={handleAddModuleModalClose}
        onAdd={handleAddModule}
        courseId={courseId}
      />

      {data ? (
        <ScrollView role="list" showsVerticalScrollIndicator={false} style={styles.scrollView}>
          {data.modules?.map((module, index) => (
            <ListItem.Accordion
              key={module.module_name}
              role="button"
              aria-label={module.module_name}
              pad={8}
              containerStyle={styles.chapterAccordion}
              isExpanded={expandedModule === module.module_name}
              content={
                <ListItem.Content
                  style={[
                    styles.chapterNameContainer,
                    { flexDirection: "row", alignItems: "center", justifyContent: "space-between" },
                  ]}>
                  <View style={{ flex: 3, paddingRight: 10 }}>
                    <CustomText
                      useTranslationText={false}
                      text={module.module_name}
                      size="m"
                      weight="medium"
                      textType="text"
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      style={{ textDecorationLine: "none", color: "#000" }}
                    />
                  </View>
                  <View
                    style={{
                      flexShrink: 0,
                      flexDirection: "row",
                      gap: 8,
                      alignItems: "center",
                    }}>
                    <TouchableOpacity
                      onPress={() => {
                        handleEditModuleName(module.module_name);
                      }}>
                      <EditIcon width={20} height={20} color={"#667085"} />
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={() => {
                        handleDeleteModule(module.module_name);
                      }}>
                      <Trash width={20} height={20} color={"#667085"} />
                    </TouchableOpacity>
                  </View>
                </ListItem.Content>
              }
              onPress={() => setExpandedModule((prev) => (prev === module.module_name ? null : module.module_name))}
              topDivider={index !== 0}>
              {module.assignments ? (
                <>
                  <ListItem.Content style={styles.addAssignmentContainer}>
                    <CustomText
                      role="header"
                      aria-level="3"
                      text="Assignments"
                      size="m"
                      weight="ultraBold"
                      textType="text"
                    />

                    <CustomButton
                      text="Add"
                      leftIcon={<PlusCircle />}
                      styleType="primaryLight"
                      size="s"
                      style={[styles.addButton, { marginLeft: isMedium ? "0" : "auto" }]}
                      textStyle={styles.addText}
                      bold={true}
                      onPress={() => handleEditAssignment(module.module_name)}
                      aria-label="Add Module"
                      accessibilityHint="Press to add Module"
                    />
                  </ListItem.Content>
                  {module.assignments.map((assignment) => (
                    <ListItem.Content
                      key={assignment.assignment_name}
                      style={[
                        styles.assignmentItem,
                        {
                          backgroundColor: selectedAssignment === assignment.assignment_name ? "#F2F5FF" : "#fff",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          flexShrink: 1,
                        },
                      ]}>
                      <TouchableOpacity
                        onPress={() => handleAssignmentPress(assignment.assignment_name, module.module_name)}>
                        <CustomText
                          useTranslationText={false}
                          text={assignment.assignment_name}
                          size="m"
                          weight="normal"
                          textType="text"
                          numberOfLines={1}
                          ellipsizeMode="tail"
                          style={[
                            styles.assignmentText,
                            {
                              maxWidth: 300,
                              flexShrink: 1,
                            },
                          ]}
                        />
                      </TouchableOpacity>
                    </ListItem.Content>
                  ))}
                </>
              ) : (
                <View style={{ paddingBottom: 15 }}>
                  <Skeleton height={34} width="98%" style={{ marginVertical: 10 }} count={4} />
                </View>
              )}
            </ListItem.Accordion>
          ))}
        </ScrollView>
      ) : (
        <View>
          <Skeleton height={34} width="98%" style={{ marginVertical: 10 }} />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  assignmentItem: {
    padding: 10,
    paddingLeft: 33,
    backgroundColor: "#fff",
  },

  assignmentText: {
    fontSize: 16,
    color: "#000",
    textDecorationLine: "none",
  },

  addAssignmentContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: 5,
    marginBottom: 10,
    paddingLeft: 30,
  },
  scrollView: {
    height: 1,
    paddingHorizontal: 20,
  },
  container: {
    top: 0,
    left: 0,
    bottom: 0,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#EAECF0",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    backgroundColor: "#fff",
    zIndex: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 8,
      height: 0,
    },
    shadowOpacity: 0.02,
    shadowRadius: 8,
    elevation: 5,
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    paddingHorizontal: 20,
    paddingTop: 40,
  },
  chapterAccordion: {
    flexDirection: "row-reverse",
    paddingRight: 16,
    paddingLeft: 0,
    paddingVertical: 12,
  },
  chapterNameContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 34,
  },
  addButton: {
    fontSize: 12,
  },
  addText: {
    paddingLeft: 10,
  },
});

export default ContentMenu;
